import React from "react";
import EiaButton from "../EiaButton";
import EiaDialog from "./EiaDialog";
import EiaSelect from "../EiaSelect";

function WithdrawBidDialog(props) {
    const { onClose, open, withdrawBid, reasonMap} = props;

    const [reasonIndex, setReasonIndex] = React.useState(0);

    const reasons = Array.from(reasonMap.values());
    const reasonKeys = Array.from(reasonMap.keys());

    const handleClickWithdraw = function() {
        withdrawBid(reasonKeys[reasonIndex]);
        onClose();
    }

    return (
        <EiaDialog open={open} onClose={onClose} title={"Please select a reason to withdraw your bid"} maxWidth={"xl"}>
            <EiaSelect title={"Withdraw Reason"} values={reasons} value={reasonIndex} onChange={(e) => setReasonIndex(e.target.value)}/>
            <EiaButton isFullWidth={true} colorTheme={"error"} onClick={handleClickWithdraw}>Withdraw</EiaButton>
        </EiaDialog>
    );
}

export default WithdrawBidDialog;